import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Subheader from 'material-ui/Subheader';
import Paper from 'material-ui/Paper';
import Error from '../../components/common/Error/Error';
import Loading from '../../components/common/Loading/Loading';
import style from '../../styles/styles';
import { getTrails } from '../../store/trails/actions';
import { getTypes } from '../../store/types/actions';
import { fetchApp } from '../../store/apps/actions';
import { getCustomFields } from '../../store/customfields/actions';
import {
    getRoadBookConfigurations,
    postRoadBookConfigurations,
} from '../../store/roadBookConfigurations/actions';
import withTranslation from '../../hoc/withTranslation';
import styles from '../page/PagePage.css';
import RoadBookConfigurationForm from '../../components/roadbook/RoadBookConfigurationForm';
import { ROAD_BOOK_CONFIGURATION_PAGE, ROAD_BOOKS_PAGE } from '../../constants/routes';

export class AddRoadBookConfigurationPage extends React.Component {
    static propTypes = {
        app: PropTypes.object,
    };

    state = {
        name: null,
    };

    componentWillMount() {
        this.fetchApplication();
        if(!this.props.loading && this.props.app){
            if (this.props.trails[this.props.currentLang].length === 0) {
                this.props.getTrails(this.props.app, this.props.currentLang);
            }
            if (this.props.types.length === 0) {
                this.props.getTypes(this.props.app.id, this.props.currentLang);
            }
            if (!this.props.customFields) {
                this.props.getCustomFields(this.props.app.id);
            }
        }

    }

    componentWillReceiveProps(nextProps, nextContext) {
        if(!this.props.loading && nextProps.app !== null){
            if (this.props.trails[nextProps.currentLang].length === 0) {
                nextProps.getTrails(nextProps.app, nextProps.currentLang);
            }
            if (this.props.types.length === 0) {
                nextProps.getTypes(nextProps.app.id, nextProps.currentLang);
            }
            if (!this.props.customFields
            ) {
                nextProps.getCustomFields(nextProps.app.id);
            }
        }
        if (this.props.sending && !nextProps.sending &&  nextProps.app !== null) {
            if (nextProps.currentRoadBookConfiguration) {
                nextProps.history.push(
                    ROAD_BOOK_CONFIGURATION_PAGE.replace(':appId', nextProps.app.id)
                        .replace(
                            ':roadBookConfigurationId',
                            nextProps.currentRoadBookConfiguration.id,
                        ),
                );
            } else {
                nextProps.history.push(ROAD_BOOKS_PAGE.replace(':appId', nextProps.app.id));
            }
        }
    }

    handleFormSubmit = async (formProps) => {
        await this.props.postRoadBookConfigurations(this.props.app.id, formProps, this.props.currentLang);
    };

    // Fetch

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app) {
            return <Loading paper={false} />;
        } else {
            return (
                <div style={styles.container}>
                    <h3 style={style.navigation}>
                        {this.props.t(
                            'module.road_book.road_book_configuration_add',
                            { name: this.props.app.name },
                        )}
                    </h3>

                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>
                                    {this.props.t('module.road_book.new_road_book_configuration')}
                                </Subheader>
                                <div style={style.paper}>
                                    <RoadBookConfigurationForm
                                        app={this.props.app}
                                        types={this.props.types}
                                        trails={this.props.trails[this.props.currentLang]}
                                        customFields={this.props.customFields}

                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.submitting}
                                    />
                                </div>
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state) {
    return {
        loading: state.apps.pending
            || state.roadBookConfigurations.pending
            || state.trails.pending
            || state.types.pending
            || state.customFields.pending,
        error: state.apps.error
            || state.roadBookConfigurations.error
            || state.trails.error
            || state.types.error
            || state.customFields.error,
        page: state.pages.currentPage,
        currentLang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.roadBookConfigurations.sending,
        currentRoadBookConfiguration: state.roadBookConfigurations.currentRoadBookConfiguration,
        trails: state.trails.content,
        types: state.types.content,
        customFields: state.customFields.content,
    };
}

export default connect(mapStateToProps, {
    getTrails,
    getTypes,
    fetchApp,
    getCustomFields,
    getRoadBookConfigurations,
    postRoadBookConfigurations,
})(withRouter(withTranslation(AddRoadBookConfigurationPage)));



// WEBPACK FOOTER //
// src/containers/roadbook/AddRoadBookAvailablePage.js